import { ToastSettings } from './types';

export const defaultToastSettings: ToastSettings = {
  variant: 'default',
  autoClose: 4000,
  hasIcon: false,
  closeOnClick: false,
};
